import { generateSitemapWithEvents } from '../helpers';

export const staticPaths = ['hub', 'resource-center', 'states'];

export const staticPathsWithLabel = [
  {
    label: 'Static Pages',
    path: '/sitemap/hub',
  },
  {
    label: 'Resource Center',
    path: '/sitemap/resource-center',
  },
  {
    label: 'State Pages',
    path: '/sitemap/states',
  },
  {
    label: 'Provider Pages',
    path: '/sitemap/providers',
  },
  {
    label: 'Agent Pages',
    path: '/sitemap/agents',
  },
];

export const staticPagesPathsWithLabel = [
  {
    label: 'Home Page',
    path: '/',
  },
  {
    label: 'Business Partners',
    path: '/partners/business',
  },
  {
    label: 'Providers',
    path: '/partners/communities',
  },
  {
    label: 'Senior Adjacent Industries',
    path: '/partners/senior-adjacent-industries',
  },
  {
    label: 'Real Estate Network',
    path: '/partners/real-estate-network',
  },
  {
    label: 'Financial Advisor Network',
    path: '/partners/financial-advisor-network',
  },
];

export const sitemapIndexBreadCrumbItems = [
  {
    path: '/',
    label: 'Home',
  },
  {
    path: '/sitemap',
    label: 'Sitemap',
  },
];

const sitemapResourceCenterBreadCrumbItems = [
  {
    path: '/',
    label: 'Home',
  },
  {
    path: '/sitemap',
    label: 'Sitemap',
  },
  {
    path: '/sitemap/resource-center',
    label: 'Resource Center',
  },
];

export const sitemapAllStatesBreadCrumbItems = [
  {
    path: '/',
    label: 'Home',
  },
  {
    path: '/sitemap',
    label: 'Sitemap',
  },
  {
    path: '/sitemap/states',
    label: 'State pages',
  },
];

export const sitemapProvidersBreadCrumbItems = [
  {
    path: '/',
    label: 'Home',
  },
  {
    path: '/sitemap',
    label: 'Sitemap',
  },
  {
    path: '/sitemap/providers',
    label: 'Provider pages',
  },
];

const sitemapStaticPagesBreadCrumbItems = [
  {
    path: '/',
    label: 'Home',
  },
  {
    path: '/sitemap',
    label: 'Sitemap',
  },
  {
    path: '/sitemap/static',
    label: 'Static Pages',
  },
];

export const SITEMAP_INDEX_BREADCRUMB_ITEMS = generateSitemapWithEvents(
  sitemapIndexBreadCrumbItems
);

export const SITEMAP_RESOURCE_CENTER_BREADCRUMB_ITEMS =
  generateSitemapWithEvents(sitemapResourceCenterBreadCrumbItems);

export const SITEMAP_STATIC_PAGES_BREADCRUMB_ITEMS = generateSitemapWithEvents(
  sitemapStaticPagesBreadCrumbItems
);

export const SITEMAP_ALL_STATES_BREADCRUMB_ITEMS = generateSitemapWithEvents(
  sitemapAllStatesBreadCrumbItems
);
